import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useCallback, useState } from 'react';

const useGetEntryWorkspace = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [workspace, setWorkspace] = useState(null);

  const getEntryWorkspace = useCallback(
    guid => {
      if (!guid) return Promise.resolve(null);

      setLoading(true);

      return axiosClient
        .get('Operation/Entry/Workspace', {
          params: { guid },
        })
        .then(res => {
          if (res.status === 200) {
            const value = res.data?.value ?? null;
            setWorkspace(value);
            return value;
          }

          enqueueSnackbar(res?.message, { variant: 'error' });
          return null;
        })
        .catch(err => {
          enqueueSnackbar(err?.message, { variant: 'error' });
          return null;
        })
        .finally(() => setLoading(false));
    },
    [enqueueSnackbar],
  );

  return { getEntryWorkspace, loading, workspace, setWorkspace };
};

export default useGetEntryWorkspace;
